import { Fragment } from 'react'
import { usePageMetaContext } from '~/src/contexts'
import { nonNullable } from '~/src/utils'
import { CONNECT_AVENUE_CATEGORY, CONNECT_FOUND_CATEGORY, CONNECT_JOBINFO_CATEGORY } from '~/src/const'
import { ConnectSection } from './ConnectSection'


export function ConnectContent() {
  const { data } = usePageMetaContext()
  const categories = data?.categories?.map(item => item?.category).filter(nonNullable) ?? []

  return (
    <div className="max-w-screen-xl mx-auto px-4">
      {
        categories.map((category, idx) => (
          <Fragment key={category.categoryId}>
            <ConnectSection 
              category={category}
              displayOption={data?.displayOption}
            />
            {idx !== categories.length - 1 && [CONNECT_AVENUE_CATEGORY, CONNECT_FOUND_CATEGORY].includes(category.categoryId) && (
              <div className="pb-10" />
            )}
          </Fragment>
        ))
      }
      <div className="mb-40" />
    </div>
  )
}